export const VideoCallBackgroundEffect = Object.freeze({
  none: 'none',
  blur: 'blur',
  background: 'background',
});
